import { render, staticRenderFns } from "./BabyShowAudit.vue?vue&type=template&id=f6deb254&"
import script from "./BabyShowAudit.vue?vue&type=script&lang=js&"
export * from "./BabyShowAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports